import produce from 'immer';
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ConsultarUsuario } from './types';

export const INITIAL_STATE: ConsultarUsuario = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ConsultarUsuario {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_USUARIO_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CONSULTAR_USUARIO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTAR_USUARIO_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTAR_USUARIO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
